import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';
import { SortDirection } from '../../../../utils/constants';

export const filterFields = {
  OrderNumber: 'OrderNumber',
  CompanyName: 'CompanyName',
  ContractName: 'ContractName',
  VesselName: 'VesselName',
  ImoNumber: 'ImoNumber',
  UserName: 'UserName',
  OrderDateFrom: 'OrderDateFrom',
  OrderDateTo: 'OrderDateTo',
  LastUpdatedBy: 'LastUpdatedBy',
  AmendmentDateFrom: 'AmendmentDateFrom',
  AmendmentDateTo: 'AmendmentDateTo',
  NumberOfKits: 'NumberOfKits',
  AwbNumber: 'AwbNumber',
  DispatchDateFrom: 'DispatchDateFrom',
  DispatchDateTo: 'DispatchDateTo',
};
const initialFilterState = {
  OrderNumber: '',
  CompanyName: '',
  ContractName: null,
  VesselName: null,
  ImoNumber: '',
  UserName: null,
  OrderDateFrom: '',
  OrderDateTo: '',
  LastUpdatedBy: null,
  AmendmentDateFrom: '',
  AmendmentDateTo: '',
  NumberOfKits: '',
  AwbNumber: '',
  DispatchDateFrom: '',
  DispatchDateTo: '',
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'CreatedOn',
  sortDirection: SortDirection.Desc,
};
export const consumableOrdersSearchsliceName = 'consumableOrdersSearch';
const consumableOrdersSlice = createSearchPageSlice({
  sliceName: consumableOrdersSearchsliceName,
  filterFields,
  initialFilterState,
  initialPageState
});
export const consumableOrdersActions = consumableOrdersSlice.actions;
export default consumableOrdersSlice.reducer;
